import { render, staticRenderFns } from "./BaseTextEditor.vue?vue&type=template&id=26ff64a0"
import script from "./BaseTextEditor.vue?vue&type=script&lang=js"
export * from "./BaseTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports